import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import HomeAboutUsTopics from './Topics';

export default function HomeAboutUs() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <h2 className={styles.container__content__title}>
          {t('about_us_label')}
        </h2>
        <HomeAboutUsTopics />
      </div>
    </div>
  );
}
